import { useEffect, useState, memo, useCallback } from "react"; 

//components
import { Dialog } from "primereact/dialog"
import ReactMarkdown from 'react-markdown';
import { Checkbox } from 'primereact/checkbox';

//api
import { TemplateService } from "../../../service/template-service";
import { Button } from "primereact/button";
import { ElaborationService } from "../../../service/elaboration-service"; 

const ElaborationTemplate = memo(({elaboration}) => { 
    const [folder, setFolder] = useState(null)
    const [openFolders, setOpenFolders] = useState({});
    const [fileContent, setFileContent] = useState(null);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewFileName, setPreviewFileName] = useState(''); 
    // eslint-disable-next-line no-unused-vars
    const [fileUrl, setFileUrl] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([])
    const [rootFolderPath, setRootFolderPath] = useState(null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [dialogHeader, setDialogHeader] = useState('');

    useEffect(()=>{
        const fetchFolder = () => {
            if (!elaboration || !elaboration.template) {
                console.warn("Elaboration template non definito, impossibile recuperare la struttura delle cartelle.");
                setFolder([]); 
                return;
            }
            TemplateService.getFolderStructure(
                elaboration.template,
                (data)=>{
                    if(data && typeof data === 'object' && Array.isArray(data.children)){
                        setFolder(data.children)
                        if (typeof data.path === 'string' && data.path.length > 0) {
                            setRootFolderPath(data.path); 
                        } else {
                            console.warn("API ha restituito un percorso radice del template non valido o vuoto:", data.path);
                            setRootFolderPath(null); 
                        }
                    } else {
                        console.error("L'API ha restituito dati non validi per la struttura delle cartelle:", data);
                        setFolder([]); 
                        setRootFolderPath(null);
                    }
                },
                (error) => { 
                    console.error("Errore durante il recupero della struttura delle cartelle:", error);
                    setFolder([]);
                    setRootFolderPath(null);
                    setDialogHeader('Errore Caricamento');
                    setDialogMessage('Errore nel caricamento della struttura delle cartelle del template.');
                    setDialogVisible(true);
                }
            )
        }
        fetchFolder();
    }, [elaboration.template]); 

    const toggleFolder = (folderPath) => {
        setOpenFolders(prev => ({
            ...prev,
            [folderPath]: !prev[folderPath]
        }));
    };

    const handleFileClick = (fileItem) => {
        if (!fileItem || !fileItem.path) {
            console.error("Elemento file non valido per l'anteprima:", fileItem);
            setDialogHeader('Errore Anteprima');
            setDialogMessage("Impossibile visualizzare l'anteprima: File non valido.");
            setDialogVisible(true);
            return;
        }

        const fullPath = fileItem.path;
        setFileContent(null);
        setFileUrl(null);
        setPreviewVisible(true);
        setPreviewFileName(fileItem.name);

        TemplateService.getFile(
            elaboration.template, 
            fullPath,
            (response) => {
                if (response && typeof response === 'object' && typeof response.content === 'string') {
                    setFileContent(response.content);
                    setFileUrl(null);
                } else {
                    console.error("Struttura di risposta API inattesa per il contenuto del file di testo:", response);
                    setFileContent("Impossibile caricare il contenuto del file. Formato dati inatteso.");
                    setDialogHeader('Errore Anteprima');
                    setDialogMessage("Impossibile caricare il contenuto del file. Formato dati inatteso.");
                    setDialogVisible(true);
                }
            },
            (error) => {
                console.error('Errore durante il recupero del contenuto del file: ', error);
                setFileContent("Errore nel caricamento del contenuto del file. Riprova più tardi.");
                setDialogHeader('Errore Anteprima');
                setDialogMessage("Errore nel caricamento del contenuto del file. Riprova più tardi.");
                setDialogVisible(true);
            }
        );
    };

    const hidePreviewDialog = ()=>{
        setPreviewVisible(false);
        setFileContent(null);
        setPreviewFileName('');
    }

    const onCheckboxChange = (file) => {
        let _selectedFiles = [...selectedFiles];
        const index = _selectedFiles.findIndex(f => f.path === file.path);

        if (index > -1) {
            _selectedFiles.splice(index, 1);
        } else {
            _selectedFiles.push(file);
        }
        setSelectedFiles(_selectedFiles);   
    };

    const renderItems = (items) => {
        if(!items || items.length === 0){
            return null;
        }

        return (
            <ul className="template__filesList">
                {items.map((item) => {
                    if(item.type === 'file' && (item.name.endsWith('.zip') || item.name.endsWith('.ZIP'))){
                        return null;
                    }

                    if(item.name === 'template'){
                        return null
                    }

                    const isChecked = selectedFiles.some(f => f.path === item.path);
                    
                    return (
                        <li key={item.path} className={`template__FilesItem ${item.type}`}>
                            {item.type === 'directory' ? (
                                <>
                                    <div
                                        className="template__FolderHeader"
                                        onClick={() => toggleFolder(item.path)}
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                    >
                                        <i className={`pi ${openFolders[item.path] ? 'pi-angle-down' : 'pi-angle-right'}`}
                                           style={{ marginRight: '8px' }}></i>
                                        <i className="pi pi-folder" style={{ marginRight: '5px' }}></i>
                                        <strong>{item.name}</strong>
                                    </div>
                                    {openFolders[item.path] && item.children && item.children.length > 0 && (
                                        renderItems(item.children)
                                    )}
                                </>
                            ) : (
                                <div className="template__FileItemContent" style={{ display: 'flex', alignItems: 'center', marginLeft: '25px' }}>
                                    <Checkbox
                                        inputId={`file_${item.path.replace(/[^a-zA-Z0-9]/g, '_')}`} 
                                        name="templateFile"
                                        value={item}
                                        style={{marginRight:'10px'}}
                                        onClick={(e) => e.stopPropagation()} 
                                        onChange={() => onCheckboxChange(item)}
                                        checked={isChecked} 
                                    />
                                    <div
                                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color:'black' }}
                                        onClick={() => handleFileClick(item)}
                                    >
                                        <i className="pi pi-file" style={{ marginRight: '5px' }}></i>
                                        <span className="template__File" style={{ textDecoration: 'underline' }}>{item.name}</span>
                                    </div>
                                </div>
                            )}
                        </li>
                    ); 
                })}
            </ul>
        )
    }

    // avvio singola elaborazione
    const handleElaboration = useCallback((elabId) => {
        const prefixToRemove = rootFolderPath + '/';
        const targetFilePaths = selectedFiles.map(file => {
            if (file.path.startsWith(prefixToRemove)) {
                const relativePath = file.path.substring(prefixToRemove.length);
                return relativePath;
            }
            return file.path;
        });

        if (targetFilePaths.length === 0) {
            setDialogHeader('Errore Elaborazione');
            setDialogMessage("Per favore, seleziona almeno un file prima di avviare l'elaborazione.");
            setDialogVisible(true);
            return;
        }

        const body = {
            target_file_paths: targetFilePaths
        }

        ElaborationService.startSingleElaboration(
            elabId,
            body,
            (response)=>{
                console.log('Elaborazione avviata con successo', response)
                setDialogHeader('Successo Elaborazione');
                setDialogMessage('Elaborazione avviata con successo!');
                setDialogVisible(true);
            },
             (error)=>{
                console.error("Errore durante l'avvio dell'elaborazione:", error);
                setDialogHeader('Errore Elaborazione');
                const errorMessage = error.error || error.message || JSON.stringify(error) || 'Errore sconosciuto durante l\'avvio dell\'elaborazione.';
                setDialogMessage(`Si è verificato un errore: ${errorMessage}`);
                setDialogVisible(true);
            }
        );
    }, [rootFolderPath, selectedFiles]); 

    return (
        <div className="template__FileContainer">
            {
                folder ? (
                    <div className="template__FileViewer">
                        {
                            folder && folder.length > 0 ? (
                                renderItems(folder)
                            ) : <p>Nessun file o cartella trovata per questo template.</p>
                        } 
                    </div>
                ) : <p>Caricamento struttura cartelle o template non valido.</p>
            } 
            <Button label="Elabora" type="button" onClick={() => handleElaboration(elaboration.id)} /> 
            <Dialog
                    header={`Contenuto di: ${previewFileName}`}
                    visible={previewVisible}
                    style={{ width: '80vw', height: '70vh' }}
                    onHide={hidePreviewDialog}
                    maximizable
            >
                {fileContent ? (
                    <div style={{ height: '100%', overflowY: 'auto', border: '1px solid #eee', padding: '15px', backgroundColor: '#f9f9f9' }}>
                        {
                            previewFileName.endsWith('.md') || previewFileName.endsWith('.MD') ? (
                                <ReactMarkdown>{fileContent}</ReactMarkdown>
                            ) : (
                                <pre style={{ whiteWhiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{fileContent}</pre>
                            )
                        }
                    </div>
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <p style={{ marginLeft: '10px' }}>Caricamento contenuto...</p>
                    </div>
                )}
            </Dialog>
            <Dialog header={dialogHeader} visible={dialogVisible} style={{ width: '50vw' }} modal onHide={() => setDialogVisible(false)}>
                <p>{dialogMessage}</p>
            </Dialog>
        </div>
    )
}) 

export default ElaborationTemplate;
